import { bl_sfa_rating_hdr_RowClass } from "../../dbschema/bl_sfa_rating_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaRatingHdrContainerModel extends BaseContainerModel {
	bl_sfa_rating_hdr: bl_sfa_rating_hdr_RowClass =
		new bl_sfa_rating_hdr_RowClass();
}
